export const queryImageAtom = groq`*[ _type=="sanity.imageAsset" && _id == $_ref][0]{altText}`;
